/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    JpCoBenefitoneBsCommonExceptionCommonExceptionHandlerSimpleErrorResponse,
    JpCoBenefitoneBsCommonExceptionCommonExceptionHandlerSimpleErrorResponseFromJSON,
    JpCoBenefitoneBsCommonExceptionCommonExceptionHandlerSimpleErrorResponseToJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseToJSON,
} from '../models';

/**
 * 
 */
export class CMSApi extends runtime.BaseAPI {

    /**
     * HeaderFooter情報を取得する
     */
    async getHeaderFooterRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/cms/header-footer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFromJSON(jsonValue));
    }

    /**
     * HeaderFooter情報を取得する
     */
    async getHeaderFooter(initOverrides?: RequestInit): Promise<JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse> {
        const response = await this.getHeaderFooterRaw(initOverrides);
        return await response.value();
    }

}
